export default {
  getSeatObj (state) {
    return state.seatObj
  }
}